import { Modal } from 'react-daisyui'
import { ShieldCheck, Lock } from 'lucide-react'
import { PortalSpinner } from 'components/PortalSpinner'

const Loader = ({
  open,
  title = 'Processing Payment',
  description = 'Please wait while we securely process your transaction. Do not refresh or close this window.',
}) => {
  return (
    <Modal open={open} backdrop className="max-w-md w-[92%] rounded-3xl border border-secondary-100 shadow-2xl bg-white p-6 sm:p-8 text-center">
      <div className="flex flex-col items-center justify-center space-y-4">
        <div className="relative flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-blue-50/80 border border-blue-100 flex items-center justify-center text-blue-600">
            <Lock size={26} className="animate-pulse" />
          </div>
        </div>

        <PortalSpinner size={10} padding="py-2" />

        <div className="space-y-1">
          <h3 className="text-lg font-bold text-secondary-900 leading-tight">{title}</h3>
          <p className="text-xs text-secondary-500 leading-relaxed max-w-xs mx-auto">{description}</p>
        </div>

        <div className="pt-2 flex items-center justify-center gap-1.5 text-[11px] font-medium text-emerald-600 bg-emerald-50/80 px-3 py-1.5 rounded-full border border-emerald-100/80">
          <ShieldCheck size={14} className="shrink-0" />
          <span>Encrypted & Secure</span>
        </div>
      </div>
    </Modal>
  )
}

export default Loader
